import React, { useState, useEffect } from 'react';
import './Dashboard.css';

import { Link } from 'react-router-dom';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

import mockup from '../../assets/mockup.png';

import GooglePlay from '../../assets/play.png';
import AppleApp from '../../assets/apple.png';
import InfoImage from '../../assets/info.png';
import PlanImage from '../../assets/group/Layer 7.png';
import VocalGrowthImage from '../../assets/group/Group 4.png';
import LearnImage from '../../assets/group/Group 5.png';
import MotorSkillsImage from '../../assets/group/Group 7.png';
import CoordinationImage from '../../assets/group/Group 6.png';
import { BASE_URL } from '../../constants';
import axios from 'axios';

const sampleCardList = {
	title: 'child care plan',
	desc: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quibusdam totam animi assumenda obcaecati voluptatem quaerat.',
	image: PlanImage,
};

const sampleTrackerCardList = {
	title: 'vocal growth',
	desc: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quibusdam totam animi assumenda obcaecati voluptatem quaerat.',
	image: VocalGrowthImage,
};

const Dashboard = (props) => {
	const { bearerToken, name } = props;
	const [cardList, setCardList] = useState([sampleCardList]);
	const [trackerCardList, setTrackerCardList] = useState([sampleTrackerCardList]);
	const trackerList = [
		{ title: 'growth tracker', to: '/growthtracker' },
		{ title: 'development tracker', to: '/' },
		{ title: 'eyesight tracker', to: '/eyesighttracker' },
		{ title: 'vaccination tracker', to: '/' },
		{ title: 'hair growth tracker', to: '/' },
		{ title: 'food tracker', to: '/' },
	];
	useEffect(() => {
		const fetchSubscriptions = () => {
			axios
				.get(`${BASE_URL}/public/home/subscription`)
				.then((response) => {
					console.log(response.data);
					setCardList(response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		};
		const fetchChildTrackers = () => {
			axios
				.get(`${BASE_URL}/public/home/childtracker`)
				.then((response) => {
					setTrackerCardList(response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		};
		fetchSubscriptions();
		fetchChildTrackers();
	}, []);
	return (
		<div className='Dashboard'>
			<Navbar bearerToken={bearerToken} />
			<div className='container'>
				<h1>
					Choose <span>Subscription Plan</span>
				</h1>
				<div className='row'>
					{cardList.map((aCard) => !!aCard.image && <PlanCard {...aCard} />)}
				</div>
				<hr />
				<h1>
					Choose <span>Child tracker</span>
				</h1>
				<div className='row'>
					{trackerCardList.map(
						(aTracker) => !!aTracker.image && <TrackerCard {...aTracker} />
					)}
				</div>
				{/* <div className='row'>
					{trackerCardList.map((aTracker) => (
						<TrackerCard {...aTracker} />
					))}
				</div> */}
			</div>
			<div className='Dashboard-tracker row'>
				{/* <div className='container'> */}
				<div className='info col s12 m4 l4'>
					<p>Tracker</p>
					<p className='plan'>Plan for your Child's</p>
					<p className='holistic'>Holistic Development</p>
				</div>
				<img src={InfoImage} className='col s12 m4 l4' />
				<div className='list col s12 m4 l4'>
					{trackerList.map((aItem) => (
						<Link to={aItem.to}>
							<li>{aItem.title}</li>
							<span className='arrowhead'>
								<i class='fas fa-chevron-right'></i>
							</span>
						</Link>
					))}
				</div>
				{/* </div> */}
			</div>
			<div className='Dashboard-lower-banner'>
				<div className='row'>
					<div className='col s12 l6 experience'>
						<div className='secondary-box right'>
							<h3>Experience India's most advanced child care app</h3>
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit.
								Exercitationem, tempore.
							</p>
							<div className='row'>
								<Link>
									<img
										className='col s12 m6'
										src={GooglePlay}
										alt='Google Play Store come here'
									/>
								</Link>
								<Link>
									<img
										className='col s12 m6'
										src={AppleApp}
										alt='Apple App Store come here'
									/>
								</Link>
							</div>
						</div>
					</div>
					<div className='col s12 l6 mockup'>
						<img src={mockup} />
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

const PlanCard = (props) => {
	const { name, about, image } = props;
	return (
		<div className='PlanCard col s12 l4'>
			<img src={image} />
			<h3>{name}</h3>
			<p>{about}</p>
			<Link href=''>Subscribe</Link>
		</div>
	);
};

const TrackerCard = (props) => {
	const { name, content, image } = props;
	return (
		<div className='TrackerCard col s12 l3'>
			<img src={image} />
			<h3>{name}</h3>
			<p>{content}</p>
			<Link href=''>Read More</Link>
		</div>
	);
};

export default Dashboard;
